import { authenticate } from 'services/app';

export const useAuthRedirect = () => {
  return async (document: string, password: string) => {
    const authResult = await authenticate(document, password);

    window.open(
      `https://app.yooga.com.br?token=${encodeURIComponent(
        authResult.token,
      )}&user=${encodeURIComponent(JSON.stringify(authResult.user))}`,
      '_blank',
    );
  };
};
